import type { ImpactOptions, VibrateOptions } from '@capacitor/haptics'
import { Haptics } from '@capacitor/haptics'

export function useNativeHaptics() {
  async function triggerVibrate(options?: VibrateOptions) {
    if (isPlatform('capacitor')) {
      await Haptics.vibrate(options)
    }
  }

  async function triggerImpact(options?: ImpactOptions) {
    if (isPlatform('capacitor')) {
      await Haptics.impact(options)
    }
  }

  return {
    triggerVibrate,
    triggerImpact
  }
}
